import React from "react";
import { Trans } from "@coworker/locales";
import AddLocation from "@coworker/components/src/components/AddLocation";
import { Widget } from "@coworker/components/src/components/Widget";
import { useInputPopup } from "../../InputPopup";
import { nonSLMFoodLocation } from "../../../services/locations.service";
import useFormatter from "../../../hooks/useFormatter";
import { getLocationPopup } from "../common/popup.helpers";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import { useAllSalesLocationsForArticleQuery } from "../../../hooks/Locations/useAllSalesLocationsForArticleQuery";
import amountTypeOptions from "@coworker/enums/amountTypes.js";

export default function TaskFormLocation({
  value: {
    code = "",
    custom = "",
    department = "",
    requestedAmount,
    actualRequestedAmount,
    requestedAmountType,
    articleId,
    articleType,
    panumber,
  },
  disabled,
  onChange,
  conf: {
    optional,
    locationString = <Trans>locationString</Trans>,
    addon,
    noArrow,
    amount,
    title,
    overridePadding,
    newAddonLocation,
  },
  additionalSubTitle = <></>,
}) {
  const { getInput } = useInputPopup();
  const [quantity, setQuantity] = React.useState(amount);
  const [ptag, setPtag] = React.useState();
  const [htag, setHtag] = React.useState();
  const lastArticleId = React.useRef(null);
  const { data: basicItem } = useItemInfo(articleId);
  const itemType = articleType ?? basicItem?.type;

  const { data: locationsData, isLoading: locationsLoading } =
    useAllSalesLocationsForArticleQuery(
      itemType && articleId ? `${itemType}${articleId}` : null
    );

  const hasNoSLMLocations = locationsData?.length <= 0;
  const isSFM = panumber?.substring(0, 2) === "96";
  const isFoodServices = panumber?.substring(0, 2) === "60";
  const isCPG = panumber?.substring(0, 2) === "61";

  const { sfmLocationList, isLoading } = nonSLMFoodLocation(
    isSFM,
    isFoodServices,
    isCPG,
    hasNoSLMLocations
  );

  const loading = (!!locationsLoading && !!locationsData) || isLoading;

  const articleLocations = hasNoSLMLocations ? sfmLocationList : locationsData;

  React.useEffect(() => {
    const found =
      !locationsLoading &&
      articleLocations?.find?.((location) =>
        code ? code === location?.location : location?.isPrimary
      );

    if (found) {
      // If no SLMLocations, set quantity to empty string, otherwise set found quantity
      if (hasNoSLMLocations) {
        setQuantity("");
      } else {
        setQuantity(found.quantity);
      }
      setPtag(found.isPrimary);
      setHtag(found.isHomeBase || found.isHome);
    }
  }, [articleLocations, code, locationsLoading, hasNoSLMLocations]);

  const { productUnit } = useFormatter();
  const baseUnitType = amountTypeOptions.PIECES;
  const displayUnit = productUnit(baseUnitType, quantity);
  // If article changes, location should be reset
  React.useEffect(() => {
    if (lastArticleId.current && lastArticleId.current !== articleId) {
      onChange({});
      setQuantity(null);
    }
    lastArticleId.current = articleId;
  }, [articleId, onChange]);
  const isFoodArticle = isSFM || isFoodServices || isCPG;

  return (
    <Widget
      tabIndex={0}
      onClick={() => {
        getLocationPopup({
          getInput,
          onChange,
          addon,
          code,
          custom,
          title,
          locationCode: code,
          locationCustom: custom,
          product_article_id: articleId,
          product_article_type: itemType,
          requestedAmount,
          actualRequestedAmount,
          requestedAmountType,
          isFoodArticle,
        });
      }}
      disabled={disabled}
      data-testid={"addLocation" + (addon || "")}
    >
      <AddLocation
        loading={loading}
        code={custom || code || ""}
        department={department || ""}
        quantity={(!custom && quantity) || ""}
        displayUnit={displayUnit}
        deactivated={disabled}
        locationString={locationString}
        addon={addon}
        optional={optional}
        ptag={!custom && ptag}
        htag={!custom && htag}
        noArrow={noArrow}
        overridePadding={overridePadding}
        newAddonLocation={newAddonLocation}
        additionalSubTitle={!custom && !code ? additionalSubTitle : <></>}
      />
    </Widget>
  );
}
